// Centralized subscription-tier helpers for KITEIQ.
// Pro-access tiers unlock all premium features; "elite" additionally grants more
// monthly credits. Keeping the list here avoids drift across the app.

export const PRO_ACCESS_TIERS = ['pro', 'pro_camp', 'elite'];

// True for any paying tier that unlocks premium features.
export const isProTier = (tier) => PRO_ACCESS_TIERS.includes(tier);

// True only for the top Elite tier.
export const isEliteTier = (tier) => tier === 'elite';

// Normalized key: 'free' | 'pro' | 'elite' (used to pick badges/labels).
export const tierKey = (tier) => {
  if (tier === 'elite') return 'elite';
  if (isProTier(tier)) return 'pro';
  return 'free';
};

// Convenience: read tier off a user object safely.
export const userIsPro = (user) => isProTier(user?.subscription_tier);
export const userIsElite = (user) => isEliteTier(user?.subscription_tier);
export const userTierKey = (user) => tierKey(user?.subscription_tier);
